import { ChevronDown, Plus } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

/**
 * Quick Actions, only actions that are actually implemented. New entries
 * (jobs, estimates, invoices, tasks, appointments) join as modules ship.
 */
const ACTIONS = [
  { label: "New Contact", to: "/contacts/create" },
  { label: "New Company", to: "/companies/create" },
  { label: "New Deal", to: "/deals/create" },
];

export const QuickActionsMenu = () => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <Button
        variant="outline"
        size="sm"
        className="h-8 gap-1.5 rounded-md border-border bg-card px-2.5 text-[12.5px] font-medium shadow-none hover:bg-accent"
      >
        <Plus className="size-3.5" />
        Quick Actions
        <ChevronDown className="size-3.5 text-muted-foreground" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-44 rounded-lg">
      {ACTIONS.map((action) => (
        <DropdownMenuItem key={action.to} asChild>
          <Link to={action.to}>{action.label}</Link>
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
